import React, { useState } from "react";
import Element from 'src/components/element';
import View from 'src/components/view';
import utils from 'src/components/utils';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { DropzoneArea, DropzoneDialog } from "material-ui-dropzone";
import { Grid, Paper, Typography } from "@material-ui/core";

function FluxoCliente() {
  let [view, setView] = useState({});
  let [cliente, setCliente] = useState({});
  let [status, setStatus] = useState([]);
  let [acoes, setAcoes] = useState([]);
  let [crud, setCrud] = useState({ data: {}, changed: {} });
  let [classificacao, setClassificacao] = useState({});
  let [ready, setReady] = useState(false);
  let [opened, setOpened] = useState(false);
  let [openedDlgAlteracoesRepresadas, setOpenedDlgAlteracoesRepresadas] = useState(false);
  let [index, setIndex] = useState(0);
  let [observacao, setObservacao] = useState('');
  let [itens, setItens] = useState({});
  let [access, setAccess] = useState(window.access ? window.access : {});

  let [isEnviarMsgWhatsappCliente,setIsEnviarMsgWhatsappCliente] = useState(true);
  let [isEnviarMsgWhatsappPai,setIsEnviarMsgWhatsappPai] = useState(true);
  let [isEnviarMsgWhatsappFilial,setIsEnviarMsgWhatsappFilial] = useState(true);
  let [notificacaoAcaoCliente, setNotificacaoAcaoCliente] = useState(null);
  let [listaAnexosNotificacao,setListaAnexosNotificacao] = useState([]);
  let [arquivoAnexoAdicional, setArquivoAnexoAdicional] = useState(null);
  let [urlAnexoAdicional, setUrlAnexoAdicional] = useState(null);
  let [showDlgAnexoAdicional, setShowDlgAnexoAdicional] = useState(false);

  let [represamentoAlteracao, setRepresamentoAlteracao] = useState(null);
  let [differences, setDifferences] = useState([]);
  let [listaAnexos, setListaAnexos] = useState([]);
  
  let cfg = {
    name: 'itens',
    type: 'list',
    layout: 'list',
    label: utils.lng('fluxo_clientes', 'Fluxo de Clientes'),
    size: 50,
    controls: false,
    showLabel: true,
    styleClass: 'ui-fluxo-grid',
    header: false,
    rowStyleClass: "${'ui-fluxo-row ui-fluxo-row-' + @this.constante}",
    list: {
      url: '/listarFluxoCliente?qs=false'
    },
    columns: {
      total: { type: 'span', filter: false, field: 'total', columnStyle: { background: '#{@this.cor}' }, columnStyleClass: "${'ui-fluxo-total ui-fluxo' + @this.constante_status}" },
      descricao: { type: 'span', filter: false, columnStyleClass: 'ui-fluxo-descricao', bold: true },
      detalhar: {
        columnStyleClass: 'ui-fluxo-expansion', style: { columnStyle: '#{@this.cor}' },
        icon: "fa fa-arrow-right"
      }
    },
    click: {
      action: "expansion",
      loading: false
    },
    sub: {
      name: 'clientes',
      type: 'list',
      layout: 'table',
      label: 'Clientes',
      rows: 10,
      add: false,
      showLabel: true,
      header: false,
      list: {
        url: '/listarClientesFluxo?status={id_status}'
      },
      columns: {
        abrir: {
          icon: "fa fa-book",
          click: {
            action: "open",
            url: '/crud/cliente/{id_cliente}'
          }
        },
        codigo: { type: 'span' },
        nome: { type: 'span' },
        tipo_descricao: { type: 'span' },
        status_descricao: { type: 'span', filter: false, columnStyleClass: 'ui-fluxo-status', bold: true },
        filial: { type: 'span' },
        dias_ultima_alteracao: { type: 'span', filter: false, bold: true, value: '${@this.dias_ultima_alteracao + " " + utils.lng("dias","dias")}' },
        detalhar: {
          icon: "fa fa-cogs",
          click: {
            action: "popup"
          },
          options: {
            icone: { type: 'icon' },
            descricao: {}
          },
          list: {
            url: 'listarFluxoCliente'
          }
        }
      }
    }
  };

  if (!ready) {
    setReady(true);

    utils.execute(crud, 'listarFluxoCliente', null, function (res) {
      setStatus(res.data);
    });
  }


  crud.globalQuery = function (el, args) {
    const d = args.data;

    console.log()
  }

  crud.open = function (value, args) {
    const click = value.click ? value.click : args.click;
    const data = args.data;
    let d = {};
    let url = click.url;

    for (const i in data) {
      const v = data[i];
      const b = '{' + i + '}';
      const c = v + '';

      url = url.replace(b, c);
    }
    d.path = url;
    d.label = click.label;

    utils.open(d);
  }

  crud.popup = function (v, args) {
    if (args.click) {
      const c = args.data;

      console.log(c);

      utils.execute(crud, 'listarAcoesCliente?status=' + c.status, null, function (res) {
        cliente = c;
        setCliente(c);
        setOpened(true);
        setAcoes(res.data);
        setObservacao('');
        represamentoAlteracao = null;
        setRepresamentoAlteracao(represamentoAlteracao);
        //loadAlteracoesRepresadas(false);
      });
    }
  };

  const selecionarAcao = function (a) {
    for (const i in acoes) {
      const s = acoes[i];

      s.selected = false;
    }
    crud.acao = a;
    crud.acao.selected = true;
    setNotificacaoAcaoCliente(notificacaoAcaoCliente = null);
    setListaAnexosNotificacao(listaAnexosNotificacao = null);
    setIndex(index + 1);
    loadAcaoCliente(crud.acao);
  };

  const loadAcaoCliente = function(acao) {
    if (acao && acao.id_acao) {
      view.loadingStart();
      utils.execute(crud, 'AcaoStatusCliente/' + acao.id_acao, null, function (res) {
        view.loadingEnd();
        if (res && res.data) {
          let acaoStatusCliente = res.data;
          if (acaoStatusCliente.notificacao) {
            notificacaoAcaoCliente = acaoStatusCliente.notificacao
            setNotificacaoAcaoCliente(notificacaoAcaoCliente);
            loadNotificacaoAcaoCliente(notificacaoAcaoCliente);
          }
        }
      });
    }
  };

  const loadNotificacaoAcaoCliente = function(notificacao) {
    if (notificacao && notificacao.id) {
      view.loadingStart();
      utils.execute(crud, 'NgsNotificacao/' + notificacao.id + '?lazy=false&ignore=usuarios', null, function (res) {
        if (res && res.data) {
          let notificacaoEager = res.data;
          if (notificacaoEager.mensagensAdicionais) {
            listaAnexosNotificacao = notificacaoEager.mensagensAdicionais.filter((msg) => {
              return msg.tipo === "DOCUMENTO";
            });
            setListaAnexosNotificacao(listaAnexosNotificacao);
          }
        }
        view.loadingEnd();
      });
    }
  };

  const switchDlgAnexoAdicional = function () {
    setShowDlgAnexoAdicional(showDlgAnexoAdicional = !showDlgAnexoAdicional);
  }
  
  const selecionarAnexo = function (anx) {
    let novoValor = !anx.selected;
    anx.selected = novoValor;
    setIndex(index + 1);
  };

  const selectImage = (files) => {
    arquivoAnexoAdicional = files && files[0] ? files[0] : null;
    setArquivoAnexoAdicional(files[0]);
  };

  const confirmar = function () {
    if (arquivoAnexoAdicional && arquivoAnexoAdicional != null) {
      uploadAnexoAdicional(arquivoAnexoAdicional);
    } else {
      gravaAcao();
    }
  };

  const uploadAnexoAdicional = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    const name = file.name;
    const extension = file.extension ? file.extension : name.indexOf('.') > 0 ? name.substring(name.lastIndexOf('.') + 1, name.length) : 'none';

    const fs = {};

    fs.preview = false;
    fs.name = name;
    fs.extension = extension;
    fs.type = file.type;
    fs.contentType = file.type;
    fs.size = file.size;

    if (!file.extension) {
        file.extension = extension;
    }

    let actions = [];
    actions.push({ label: utils.lng('confirmar', 'Confirmar'), action: () => {} })
    try {
      let url = utils.getUrlApi()+"/cdn/simple/upload?token="+utils.getToken();
      // url += "&id_credencial="+credencialSelecionada.id;
      // url += "&preview="+false;
      // url += "&name="+name;
      // url += "&extension="+extension;
      // url += "&type="+file.type;
      // url += "&size="+file.size;

      const response = await fetch(url, {
        method: "POST",
        params: fs,
        body: formData,
        headers: {},
      });
  
      if (response.ok) {
        const result = await response.json();
        console.log("Resposta da API:", result);
        if (result && result.data) {
          urlAnexoAdicional = result.data.url;
          setUrlAnexoAdicional(urlAnexoAdicional);
          gravaAcao();
        }
      } else {
        const error = await response.text();
        console.error("Erro:", error);
        if (window.dialog) {
          window.dialog.alert(utils.lng("ocorreu_erro_enviar_arquivo", "Ocorreu um erro ao enviar o arquivo.") + "\n\n" + error,null,actions);
        }
      }
    } catch (error) {
      console.error("Erro:", error);
      if (window.dialog) {
        window.dialog.alert(utils.lng("ocorreu_erro_enviar_arquivo", "Ocorreu um erro ao enviar o arquivo.") + "\n\n" + error,null,actions);
      }
    }
  }

  const gravaAcao = function () {
    const _call_ = {};
    const put = {};
    const sel = {};

    put.method = 'PUT';
    put.alert = true;
    put.url = 'Cliente/' + cliente.id;

    sel.observacao = observacao;

    if (crud.acao) {
      sel.status = crud.acao.id_status;
      sel.id_acao = crud.acao.id_acao;
      sel.constante_acao = crud.acao.constante_acao;
    }

    sel.isEnviarMsgWhatsappCliente = isEnviarMsgWhatsappCliente
    sel.isEnviarMsgWhatsappPai = isEnviarMsgWhatsappPai;
    sel.isEnviarMsgWhatsappFilial = isEnviarMsgWhatsappFilial;
    sel.listaAnexosSelecionados = listaAnexosNotificacao;
    sel.urlAnexoAdicional = urlAnexoAdicional;
        

    _call_.global = true;
    _call_.element = {};
    _call_.cfg = put;
    _call_.complete = function () {
      setOpened(false);
      itens.refresh();
    };
    _call_.data = sel;
    _call_.changed = sel;
    _call_.crud = crud;
    _call_.view = view;

    utils.call(_call_);
  };

  const onChangeObservacao = function (event) {
    let val = event.target.value;

    setObservacao(val);
  }

  const closeDialog = function () {
    setOpened(false);
  }

  const opts = {
    elements: {
      ver_entrevista: {
        rendered: '${exists(@this,"id_entrevista")}',
        type: 'link',
        value: 'Ver entrevista',
        href: "${'/ver_entrevista/' + @this.id_entrevista}"
      },
      ver_consultor: {
        type: 'link',
        value: 'Ver consultor',
        href: "${'/consultores/' + @this.id_consultor}"
      }
    }
  };

  view.onCheck = function (a) {
    setCrud(crud);
    setItens(itens);

    access = a;

    if (access.CADASTRAR !== false) {
      cfg.add = {
        action: "open",
        url: '/crud/Cliente/0'
      };
    }
    setItens(cfg);

    setAccess(a);
    setIndex(index + 1);
  }

  const confirmaAtivacao = function () {
    let _ks_ = {};

    _ks_.global = true;
    _ks_.crud = crud;
    _ks_.changed = {};
    _ks_.element = {};

    _ks_.cfg = {
      url: `confirma/ativacao/cliente/${cliente.id}`,
      method: 'POST'
    };
    _ks_.complete = function(res) {
      setOpened(false);
      itens.refresh();
    }
    utils.call(_ks_);
  }

  //REPRESAMENTO ALTERAÇÕES
  /*
  const visualizarAlteracoesRepresadas = function() {
    if (!represamentoAlteracao) {
      loadAlteracoesRepresadas(true);
    } else {
      openedDlgAlteracoesRepresadas = true;
      setOpenedDlgAlteracoesRepresadas(openedDlgAlteracoesRepresadas);
    }
  };

  const loadAlteracoesRepresadas = function(openWindow) {
    if (cliente && cliente.id > 0) {
      view.loadingStart();
      utils.execute(crud, 'consulta/represamento_alteracao/cliente/' + cliente.id, null, function (res) {
        if (res && res.data) {
          represamentoAlteracao = res.data;
          setRepresamentoAlteracao(represamentoAlteracao);
          if (represamentoAlteracao.anexos) {
            listaAnexos = represamentoAlteracao.anexos;
            setListaAnexos(listaAnexos);
          }
          differences = flattenDifferences(
            represamentoAlteracao?.versao_atual || {},
            represamentoAlteracao?.versao_nova || {}
          );
          setDifferences(differences);
          if (openWindow) {
            openedDlgAlteracoesRepresadas = true;
            setOpenedDlgAlteracoesRepresadas(openedDlgAlteracoesRepresadas);
          }
        }
        view.loadingEnd();
      });
    }
  };

  const closeDialogAlteracoesRepresadas = function() {
    openedDlgAlteracoesRepresadas = false;
    setOpenedDlgAlteracoesRepresadas(openedDlgAlteracoesRepresadas);
  }

  const rejeitarAlteracoesRepresadas = function() {
    postRespostaAlteracaoRepresada('rejeitar');
  }

  const aprovarAlteracoesRepresadas = function() {
    postRespostaAlteracaoRepresada('aprovar');
  }

  const postRespostaAlteracaoRepresada = function (resposta) {
    let _ks_ = {};

    _ks_.global = true;
    _ks_.crud = crud;
    _ks_.changed = {};
    _ks_.element = {};

    _ks_.cfg = {
      url: `alteracoes_represadas/`+resposta+'/'+represamentoAlteracao.id,
      method: 'POST'
    };
    _ks_.complete = function(res) {
      closeDialogAlteracoesRepresadas();
      itens.refresh();
    }
    utils.call(_ks_);
  }

  const isObject = (value) => {
    return value && typeof value === 'object' && !Array.isArray(value);
  };

  const flattenDifferences = (current, updated, path = '') => {

  const result = [];

  const keys = new Set([
    ...Object.keys(current || {}),
    ...Object.keys(updated || {})
  ]);

  keys.forEach((key) => {

    if (key === 'id') {
      return;
    }

    const oldValue = current ? current[key] : undefined;
    const newValue = updated ? updated[key] : undefined;

    const currentPath = path ? `${path}.${key}` : key;

    // ARRAY
    if (Array.isArray(oldValue) || Array.isArray(newValue)) {

      result.push({
        field: currentPath,
        oldValue: oldValue || [],
        newValue: newValue || [],
        type: 'array'
      });

      return;
    }

    // OBJECT
    if (isObject(oldValue) || isObject(newValue)) {

      result.push(
        ...flattenDifferences(
          oldValue || {},
          newValue || {},
          currentPath
        )
      );

      return;
    }

    // FIELD
    if (JSON.stringify(oldValue) === JSON.stringify(newValue)) {
      return;
    }
    result.push({
      field: currentPath,
      oldValue,
      newValue,
      type: 'field'
    });

  });

  return result;
};

const renderArrayItems = (items, color) => {

  if (!items || items.length === 0) {
    return null;
  }

  return items.map((item, index) => (

    <div
      key={index}
      className="fluxo-clientes-diff-listitem"
      style={{
        borderLeft: `4px solid ${color}`
      }}
    >

      {Object.keys(item).map((key) => {

        if (key === 'id') {
          return null;
        }

        return (
          <div key={key} style={{ marginBottom: 6 }}>
            <strong>{key}:</strong> {String(item[key])}
          </div>
        );
      })}

    </div>
  ));
};

const renderValue = (value) => {

  if (value === null || value === undefined) {
    return '-';
  }

  if (typeof value === 'object') {
    return JSON.stringify(value, null, 2);
  }

  return String(value);

};

const fieldToLabel = function (fieldName) {

  if (!fieldName) {
    return '';
  }

  const ignorar = [ 'id', 'constante' ];

  return fieldName
    .split('.')
    .filter(parte => !ignorar.includes(parte))
    .map(parte => utils.normalizarTexto(parte))
    .join(' / ');
}
*/


  return (
    <View name="ui-fluxo" view={view}>
      <div className="ui-fluxo-data">
        <Dialog
          open={opened}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{utils.lng('escolha_uma_acao', 'Escolha uma ação')}</DialogTitle>
          <DialogContent>
            {cliente.exists_consultor && cliente.verificacao_ativacao_pendente !== true &&
              <Element crud={crud} value={opts} data={cliente} view={view} />
            }

            {cliente.status_constante == 'ATIVO' && cliente.verificacao_ativacao_pendente === true &&
              <Button onClick={confirmaAtivacao} style={{ paddingBottom: '20px', display: 'block' }} >
                {utils.lng('cadastro_validado', 'Cadastro Validado')}
              </Button>
            }

            {/*{cliente.status_constante === 'ALTERACAO_DADOS' &&
              <Button onClick={visualizarAlteracoesRepresadas} style={{ paddingBottom: '20px', display: 'block' }} >
                {utils.lng('visualizarAlteracoes', 'Visualizar Alterações')}
              </Button>
            }*/}

            <div className="ui-client-opts">
              {acoes.map((li, ib) => (
                <div className="ui-opt-item" onClick={() => { selecionarAcao(li) }}>
                  <div className="ui-opt-icon">
                    <i className={li.selected ? ' far fa-check-circle' : ' far fa-circle'} ></i>
                  </div>
                  <div className="ui-opt-description">
                    {li.descricao}
                  </div>
                </div>
              ))}
            </div>
            <div className="ui-opt-observacao" style={{ marginTop: '15px' }}>
              <TextField variant="outlined" label={utils.lng('observacao', 'Observação')} rows={3} multiline={true}
                value={observacao} onChange={onChangeObservacao}> </TextField>
            </div>
            
            {notificacaoAcaoCliente && notificacaoAcaoCliente != null &&
              <>
                <div className="ui-client-opts">
                  <div className="ui-opt-item" onClick={() => { setIsEnviarMsgWhatsappCliente(isEnviarMsgWhatsappCliente = !isEnviarMsgWhatsappCliente) }}>
                    <div className="ui-opt-icon">
                      <i className={isEnviarMsgWhatsappCliente ? ' far fa-check-circle' : ' far fa-circle'} ></i>
                    </div>
                    <div className="ui-opt-description">
                      {utils.lng('enviar_notificacao_di', "Enviar Notificação para D.I")}
                    </div>
                  </div>

                  <div className="ui-opt-item" onClick={() => { setIsEnviarMsgWhatsappPai(isEnviarMsgWhatsappPai = !isEnviarMsgWhatsappPai) }}>
                    <div className="ui-opt-icon">
                      <i className={isEnviarMsgWhatsappPai ? ' far fa-check-circle' : ' far fa-circle'} ></i>
                    </div>
                    <div className="ui-opt-description">
                      {utils.lng('enviar_notificacao_1o_di_ascendente', "Enviar Notificação para o 1º D.I Ascendente")}
                    </div>
                  </div>

                  <div className="ui-opt-item" onClick={() => { setIsEnviarMsgWhatsappFilial(isEnviarMsgWhatsappFilial = !isEnviarMsgWhatsappFilial) }}>
                    <div className="ui-opt-icon">
                      <i className={isEnviarMsgWhatsappFilial ? ' far fa-check-circle' : ' far fa-circle'} ></i>
                    </div>
                    <div className="ui-opt-description">
                      {utils.lng('enviar_notificacao_filial_di', "Enviar Notificação para a Filial do D.I")}
                    </div>
                  </div>
                </div>
              
                {listaAnexosNotificacao && listaAnexosNotificacao != null &&
                  <>
                    <div className="ui-opt-description" style={{marginTop: '20px'}}>
                      {utils.lng('selecionar_anexos_enviar','Selecionar Anexos padronizados para enviar')}
                    </div>

                    <div className="ui-client-opts">
                      {listaAnexosNotificacao.map((anexo, ib) => (
                        <div className="ui-opt-item" onClick={() => { selecionarAnexo(anexo) }}>
                          <div className="ui-opt-icon">
                            <i className={anexo.selected ? ' far fa-check-circle' : ' far fa-circle'} ></i>
                          </div>
                          <div className="ui-opt-description">
                            {anexo.descricao}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                }

                <div className="ui-client-opts" style={{marginTop: '20px'}}>
                  <div className="ui-opt-description">
                    {utils.lng('selecionar_anexo_adicional_opcional','Selecionar Anexo Adicional (Opcional)')}
                    {/* <Button onClick={switchDlgAnexoAdicional} variant="contained" color="primary" style={{marginLeft: '10px'}}>{utils.lng('selecionar_imagem', 'Selecionar Imagem')}</Button> */}
                  </div>

                  <div style={{ marginTop: "20px" }}>
                    <DropzoneArea
                      cancelButtonText={utils.lng("cancelar", "Cancelar")}
                      className="ui-dlg-upload"
                      dropzoneText={utils.lng('enviar', 'Enviar')}
                      dialogTitle={utils.lng('enviar', 'Enviar')}
                      
                      onChange={(files) => { selectImage(files); }}
                      onDelete={(files) => { selectImage(files); }}
                      acceptedFiles={["image/jpeg", "image/png", "image/jpg"]}
                      filesLimit={1}
                      maxFileSize={50000000}
                      open={showDlgAnexoAdicional}
                      onClose={() => switchDlgAnexoAdicional()}
                      onSave={(files) => { selectImage(files); }}
                    />
                  </div>
                  
                </div>
              </>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDialog} variant="contained" color="primary">{utils.lng('fechar', 'Fechar')}</Button>
            <Button onClick={confirmar} variant="contained" color="primary">{utils.lng('confirmar', 'Confirmar')}</Button>
          </DialogActions>
        </Dialog>

        {/*
        <Dialog open={openedDlgAlteracoesRepresadas} maxWidth="md" fullWidth>

          <DialogTitle> { utils.lng('alteracoes', 'Alterações') } </DialogTitle>

          <DialogContent dividers>

            {listaAnexos && listaAnexos.length > 0 && (

              <div
                style={{
                  marginBottom: 20,
                  padding: 16,
                  border: '1px solid #E0E0E0',
                  borderRadius: 8,
                  background: '#FAFAFA'
                }}
              >

                <Typography
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    marginBottom: 12
                  }}
                >
                  {utils.lng('comprovantes','Comprovantes')}
                </Typography>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 8
                  }}
                >

                  {listaAnexos.map((anexo) => (

                    <a
                      key={anexo.id}
                      href={anexo.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: '#1976D2',
                        textDecoration: 'none',
                        fontWeight: 500
                      }}
                    >
                      {anexo.descricao}
                    </a>

                  ))}

                </div>

              </div>

            )}

            {differences.map((diff, index) => {

              const isArray = diff.type === 'array';

              return (

                <Paper key={index} className="fluxo-clientes-diff-card" >

                  <Typography className="fluxo-clientes-diff-title"> { fieldToLabel( diff.field ) } </Typography>

                  <Grid container spacing={2}>

                    <Grid item xs={5}>

                      <div className="fluxo-clientes-diff-oldbox">

                        <div className="fluxo-clientes-diff-label">{utils.lng('valor_atual','Valor atual')}</div>

                        <div className="fluxo-clientes-diff-oldvalue">

                          {!isArray && (
                            renderValue(diff.oldValue)
                          )}

                          {isArray && (
                            renderArrayItems( diff.oldValue, '#C62828' )
                          )}

                        </div>

                      </div>

                    </Grid>

                    <Grid item xs={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                      <Typography variant="h5"> → </Typography>

                    </Grid>

                    <Grid item xs={5}>

                      <div className="fluxo-clientes-diff-newbox">

                        <div className="fluxo-clientes-diff-label">{utils.lng('novo_valor','Novo valor')}</div>

                        <div className="fluxo-clientes-diff-newvalue">

                          {!isArray && (
                            renderValue(diff.newValue)
                          )}

                          {isArray && (
                            renderArrayItems( diff.newValue, '#2E7D32' )
                          )}

                        </div>

                      </div>

                    </Grid>

                  </Grid>

                </Paper>
              );
            })}

          </DialogContent>

          <DialogActions>

            <Button onClick={closeDialogAlteracoesRepresadas} variant="contained" color="primary">
              {utils.lng('fechar', 'Fechar')}
            </Button>

          </DialogActions>

        </Dialog>
        */}

        <Element value={itens} crud={crud} data={crud.data} view={view} ></Element>
      </div>
    </View >
  );
}


export default FluxoCliente;